import React from 'react';
import PortalPageTemplate from './PortalPageTemplate';

const PortalTeacherPage = () => (
  <PortalPageTemplate
    eyebrow="TEACHER"
    title="강사 포털"
    description="출결 확인과 타자 승인 등 수업에 필요한 메뉴를 모았어요."
  />
);

export default PortalTeacherPage;
